import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from '@/app/common/components/Card'
import Label from '@/app/common/components/Label'
import { SubmitButton } from '@/app/common/components/SubmitButton'
import { ProviderPreviewSettings } from '@/schemas/provider.schema'
import { Checkbox } from '@/shad/ui/checkbox'
import { selectSelectedProgram } from '@/storage/programs/slice'
import { CheckedState } from '@radix-ui/react-checkbox'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useUpdatePreviewSettings } from '../hooks/useUpdatePreviewSettings'
import AdminAuthGuard from '../../../admin-auth-guard'
// import StoreSettings from "@/app/pages/setup/configureStore/components/StoreSettings.tsx";

type Props = {
  provider: ProviderPreviewSettings
  providerId: string
}

const MarketplaceSettings = (props: Props) => {
  const { provider, providerId } = props
  const programId = useSelector(selectSelectedProgram).id
  const [marketplace, setMarketplace] = useState<number>(
    provider.marketplace ?? 0
  )
  const [isAcceptingNewClients, setIsAcceptingNewClients] = useState<0 | 1>(
    provider?.accepting_new_clients ?? 0
  )
  const [allowsInStorePickup, setAllowsInStorePickup] = useState<0 | 1>(
    provider?.allow_in_store_pickup ?? 0
  )

  const updateSettingMutation = useUpdatePreviewSettings({
    providerId: providerId,
  })

  const onMarketplaceChange = (checked: CheckedState) => {
    setMarketplace(checked ? 1 : 0)
  }

  const onClientsChange = (checked: CheckedState) => {
    setIsAcceptingNewClients(checked ? 1 : 0)
  }

  const onPickupChange = (checked: CheckedState) => {
    setAllowsInStorePickup(checked ? 1 : 0)
  }

  const onSubmit = async () => {
    updateSettingMutation.mutate({
      program_id: programId,
      marketplace,
      accepting_new_clients: isAcceptingNewClients,
      allow_in_store_pickup: allowsInStorePickup,
    })
  }

  return (
    <>
      <Card className="w-full">
        <CardHeader className="font-semibold text-lg">
          Store Settings
        </CardHeader>

        <div className="">
          <CardContent>
            <div className="space-y-4">
              <div className="flex gap-x-3 items-center">
                <Checkbox
                  onCheckedChange={onMarketplaceChange}
                  id="marketplace"
                  checked={marketplace == 1}
                  className="h-5 w-5"
                />
                <Label htmlFor="marketplace">
                  Display Store in Marketplace
                </Label>
              </div>
              <div className="flex gap-3 items-center">
                <Checkbox
                  onCheckedChange={onClientsChange}
                  id="new_clients"
                  checked={isAcceptingNewClients == 1}
                  className="h-5 w-5"
                />
                <Label htmlFor="new_clients">Accepting New Clients</Label>
              </div>
              <div className="flex gap-3 items-center">
                <Checkbox
                  onCheckedChange={onPickupChange}
                  id="store_pickup"
                  checked={allowsInStorePickup == 1}
                  className="h-5 w-5"
                />
                <Label htmlFor="store_pickup">Allow In-Store Pickup</Label>
              </div>
            </div>
          </CardContent>
          <CardFooter className="flex justify-end py-4 border-t border-gray-200">
            <AdminAuthGuard requiredPermissions={['provider_management_edit']}>
              <div className="">
                <SubmitButton
                  onClick={onSubmit}
                  aria-label={'save_changes'}
                  status={updateSettingMutation.status}
                />
              </div>
            </AdminAuthGuard>
          </CardFooter>
        </div>
      </Card>
    </>
  )
}
export default MarketplaceSettings
